/* eslint-disable max-len */
import Logo from '../../../../assets/princiDis.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  principle1TabQuestions,
  principle2TabQuestions,
  principle3TabQuestions,
  principle4TabQuestions,
  principle5TabQuestions,
  principle6TabQuestions,
  principle7TabQuestions,
  principle8TabQuestions,
  principle9TabQuestions
} from './principleWisePerformanceDisclosureTabs';

export const principleWisePerformanceDisclosure = {
  header: {
    imageUrl: Logo,
    title: 'SECTION C: PRINCIPLE WISE PERFORMANCE DISCLOSURE',
    description: `This section is aimed at helping entities demonstrate their performance in integrating the Principles 
    and Core Elements with key processes and decisions. The information sought is categorized as “Essential” and “Leadership”. 
    While the essential indicators are expected to be disclosed by every entity that is mandated to file this report, the leadership 
    indicators may be voluntarily disclosed by entities which aspire to progress to a higher level in their quest to be socially, 
    environmentally and ethically responsible.`,
    noOfModules: 34,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.BRSR.pwpDisclocure,
  tabs: [
    {
      id: 'principle1',
      title: 'Principle 1',
      principleTitle:
        'Businesses should conduct and govern themselves with integrity, and in a manner that is Ethical, Transparent and Accountable',
      questions: principle1TabQuestions,
      accordion: true
    },
    {
      id: 'principle2',
      title: 'Principle 2',
      principleTitle:
        'Businesses should provide goods and services in a manner that is sustainable and safe',
      questions: principle2TabQuestions,
      accordion: true
    },
    {
      id: 'principle3',
      title: 'Principle 3',
      principleTitle:
        'Businesses should respect and promote the well-being of all employees, including those in their value chains',
      questions: principle3TabQuestions,
      accordion: true
    },
    {
      id: 'principle4',
      title: 'Principle 4',
      principleTitle:
        'Businesses should respect the interests of and be responsive to all its stakeholders',
      questions: principle4TabQuestions,
      accordion: true
    },
    {
      id: 'principle5',
      title: 'Principle 5',
      principleTitle: 'Businesses should respect and promote human rights',
      questions: principle5TabQuestions,
      accordion: true
    },
    {
      id: 'principle6',
      title: 'Principle 6',
      principleTitle:
        'Businesses should respect and make efforts to protect and restore the environment',
      questions: principle6TabQuestions,
      accordion: true
    },
    {
      id: 'principle7',
      title: 'Principle 7',
      principleTitle:
        'Businesses, when engaging in influencing public and regulatory policy, should do so in a manner that is responsible and transparent',
      questions: principle7TabQuestions,
      accordion: true
    },
    {
      id: 'principle8',
      title: 'Principle 8',
      principleTitle:
        'Businesses should promote inclusive growth and equitable development',
      questions: principle8TabQuestions,
      accordion: true
    },
    {
      id: 'principle9',
      title: 'Principle 9',
      principleTitle:
        'Businesses should engage with and provide value to their consumers in a responsible manner',
      questions: principle9TabQuestions,
      accordion: true
    }
  ]
};
